import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

/**
 * Guard pre beta geo-gate. Ak je účet v čakacom stave (area_pending === true —
 * mimo dostupnej beta oblasti), presmeruje na /waiting-area namiesto vpustenia
 * do hlavnej aplikácie (Objavuj, Hľadaj, Chat…). Profil a nastavenia ostávajú
 * prístupné, aby si používateľ mohol upraviť mesto.
 */
export function RequireActiveArea({ children }: Props) {
  const stored = localStorage.getItem('user');
  if (!stored) return <>{children}</>;

  try {
    const u = JSON.parse(stored);
    if (u.area_pending === true) {
      return <Navigate to="/waiting-area" replace />;
    }
  } catch {
    // poškodený JSON — necháme prejsť
  }

  return <>{children}</>;
}
